import { render } from "./RegisterPhotographerForm.vue?vue&type=template&id=eb57adac&scoped=true"
import script from "./RegisterPhotographerForm.vue?vue&type=script&lang=js"
export * from "./RegisterPhotographerForm.vue?vue&type=script&lang=js"

import "./RegisterPhotographerForm.vue?vue&type=style&index=0&id=eb57adac&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb57adac"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QCard,QForm,QInput,QCardActions,QBtn});
